module.exports = __webpack_public_path__ + "img/handbook_popup_ring.9eb251b3.png";